import { render } from "./VoteNotAvailable.vue?vue&type=template&id=429679c6&scoped=true"
import script from "./VoteNotAvailable.vue?vue&type=script&lang=js"
export * from "./VoteNotAvailable.vue?vue&type=script&lang=js"

import "./VoteNotAvailable.vue?vue&type=style&index=0&id=429679c6&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429679c6"]])

export default __exports__